import { Photo } from '@core/models';

export const PHOTOS: Photo[] = [];
